"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */

const HotelConfirmedIcon = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#2F73D2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.1666 15.8334H25.8333C27.6749 15.8334 29.1666 17.3251 29.1666 19.1667V26.6667H27.4999V24.1667H12.4999V26.6667H10.8333V14.1667H12.4999V21.6667H19.1666V15.8334ZM18.3333 18.3334C18.3333 19.7167 17.2166 20.8334 15.8333 20.8334C14.4499 20.8334 13.3333 19.7167 13.3333 18.3334C13.3333 16.9501 14.4499 15.8334 15.8333 15.8334C17.2166 15.8334 18.3333 16.9501 18.3333 18.3334Z",
    fill: "white"
  }));
};
var _default = exports.default = HotelConfirmedIcon;